// src/utils/aiGenerator.js
export async function generateAIOutput(model, prompt, onStreamChunk) {
  if (!model) throw new Error("AI model not selected.");
  if (!prompt) throw new Error("Prompt is empty.");

  let selectedModel;
  let endpoint;

  switch (model.model) {
    case "deepseek":
      selectedModel = "deepseek-chat";
      endpoint = process.env.REACT_APP_DEEPSEEK_ENDPOINT;
      break;
    case "qwen":
      selectedModel = "Qwen/Qwen2.5-VL-72B-Instruct-AWQ";
      endpoint = process.env.REACT_APP_QWEN_ENDPOINT;
      break;
    case "chatgpt":
      selectedModel = "gpt-4o";
      endpoint = process.env.REACT_APP_CHATGPT_ENDPOINT;
      break;
    case "gemini":
      selectedModel = "gemini-2.5-flash";
      endpoint = process.env.REACT_APP_GEMINI_ENDPOINT;
      break;
    default:
      throw new Error("Unsupported model type.");
  }

  // Prepare request body
  const requestBody =
    model.model === "chatgpt"
      ? {
          model: selectedModel,
          input: [{ role: "user", content: prompt }],
          stream: true,
        }
      : model.model === "gemini"
      ? {
          model: selectedModel,
          contents: [
            {
              role: "user",
              parts: [{ text: prompt }],
            },
          ],
        }
      : {
          model: selectedModel,
          messages: [{ role: "user", content: prompt }],
          stream: true,
        };

  // Prepare headers
  const headers = {
    "Content-Type": "application/json",
    ...(model.model === "gemini"
      ? { "x-goog-api-key": model.apiKey }
      : { Authorization: `Bearer ${model.apiKey}` }),
  };

  const response = await fetch(endpoint, {
    method: "POST",
    headers,
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let accumulatedText = "";

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    const chunk = decoder.decode(value, { stream: true });
    const lines = chunk.split("\n").filter((line) => line.trim() !== "");

    for (let line of lines) {
      line = line.trim();
      if (!line.startsWith("data: ")) continue;

      const data = line.replace("data: ", "").trim();
      if (data === "[DONE]") return accumulatedText;

      try {
        const parsed = JSON.parse(data);

        const textChunk =
          // Gemini
          parsed.candidates?.[0]?.content?.parts
            ?.map((p) => p.text)
            .join("") ||
          // OpenAI-style
          parsed.choices?.[0]?.delta?.content ||
          "";

        if (textChunk) {
          accumulatedText += textChunk;
          if (onStreamChunk) onStreamChunk(accumulatedText);
        }
      } catch (e) {
        console.error("Error parsing chunk:", e, line);
      }
    }
  }

  return accumulatedText;
}
